.game {
    margin: 60px 0;
    display: flex;
    justify-content: center;
    transform-origin: top left;

    iframe {
        border: none;
    }
}